<template>
    <b-card class="mb-5">
        <b-row>
            <b-col md="6">
                <h3>{{$route.name}}</h3>
                <b-breadcrumb>
                    <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
            <b-col md="6 mt-3 float-right">
                <b-button variant="primary" class="mb-2 float-right btn-custom" :to="'department/create'"><font-awesome-icon icon="plus"/></b-button>
            </b-col>
        </b-row>
        <div class="border-bottom"></div>
        <b-row>
            <b-col md="12">
                <div v-if="$store.getters['account/accountData'].roleDownStream[0].role === 'ADMIN'">
                    <b-row class="mt-3 mb-2">
                        <b-col md="3 mb-2">
                            <b-form-select v-model="tableFilter.company" :options="companyList" />
                        </b-col>
                        <b-col md="3 mb-2">
                            <b-form-select v-model="tableFilter.branch" :options="branchList" />
                        </b-col>
                        <b-col md="1">
                            <b-button variant="light" style="margin-left:-85px!important; padding-bottom:6px!important;" disabled><font-awesome-icon icon="spinner" spin v-if="isLoadingBranch" />
                            </b-button>
                        </b-col>
                    </b-row>
                </div>
                <div v-else>
                    <b-row class="mt-3 mb-3">
                        <b-col md="3">
                            <b-form-select v-model="tableFilter.branch" :options="branchOnlyList" />
                        </b-col>
                    </b-row>
                </div>
            </b-col>
        </b-row>
        <paginated-table ref="dataTable" :can-delete="false" :can-show="true" :can-edit-modal="false" :can-edit="true" :can-reject="false" :can-approve="false" :data-url="apiUrl" :data-key="dataKey" :data-columns="columns" :data-params="['company_uuid', 'branch_uuid']">
        </paginated-table>
    </b-card>
</template>
<script>
    import PaginatedTable from '@/components/PaginatedTable'
    export default {
        name: 'department',
        components: {
            PaginatedTable
        },
        data () {
            return {
                isLoadingBranch: false,
                dataKey: 'department',
                apiUrl: window.AppConfig.apiUrl + 'department',
                columns: [
                    {
                        key: 'name',
                        label: 'Name',
                        sortable: true
                    },
                    {
                        key: 'company',
                        label: 'Company',
                        sortable: true
                    },
                    {
                        key: 'branchDepartment',
                        label: 'Branch',
                        sortable: true
                    },
                    {
                        key: 'statusDepartment',
                        label: 'Status',
                        sortable: false
                    },
                    {
                        key: 'actions',
                        label: '',
                        sortable: false
                    }
                ],
                tableFilter: {
                    company_uuid: this.$route.query.company_uuid,
                    company: null,
                    branch_uuid: this.$route.query.branch_uuid,
                    branch: null,
                },
                companyList: [
                    {
                        value: null,
                        text: 'Company'
                    }
                ],
                branchList: [
                    {
                        value: null,
                        text: 'Branch'
                    }
                ],
                branchOnlyList: [
                    {
                        value: null,
                        text: 'Branch'
                    }
                ],
            }
        },
        watch: {
            'tableFilter.company' (value) {
                this.getBranch(value)
            },
            'tableFilter.branch' () {
                this.doFilter()
            }
        },
        mounted() {
            this.getCompany()
            this.getBranchOnly()
            // this.getBranch()
        },
        methods: {
            doFilter () {
                this.tableFilter.company_uuid = this.tableFilter.company
                this.tableFilter.branch_uuid = this.tableFilter.branch
                this.tableFilter.branch_uuid_only = this.tableFilter.branchOnly
                this.$refs.dataTable.doFilter(this.tableFilter)
            },
            doSubmit () {
                this.$validator.validateAll().then(res => {
                if (res) {
                    this.isLoading = true
                    if (this.model.uuid !== null) {
                    let model = {}
                    Object.keys(this.model).forEach(element => {
                        if (element !== 'uuid') {
                        model[element] = this.model[element]
                        }
                    })
                    this.$http.patch(this.apiUrl + '/' + this.model.uuid, model).then(response => {
                        this.isLoading = false
                        this.$store.dispatch('notification/success', 'Department successfully updated.')
                        this.$refs.dataTable.getDataTable()
                        this.resetData()
                        this.hideModal()
                    }).catch(error => {
                        this.isLoading = false
                        this.$store.dispatch('notification/error', error)
                    })
                    } else {
                    this.$http.post(this.apiUrl, this.model).then(response => {
                        this.isLoading = false
                        this.$store.dispatch('notification/success', 'Department successfully added.')
                        this.hideModal()
                        this.resetData()
                        this.$refs.dataTable.getDataTable()
                    }).catch(error => {
                        this.isLoading = false
                        this.$store.dispatch('notification/error', error)
                    })
                    }
                }
                })
            },
            getCompany () {
              this.$http.get(window.AppConfig.apiUrl + 'company?limit=100').then(response => {
                response.data._embedded.company.forEach(data => {
                    this.companyList.push({
                      value: data.uuid,
                      text: data.name
                    })
                })
              })
            },
            getBranchOnly () {
              this.$http.get(window.AppConfig.apiUrl + 'branch?limit=100&is_active=1').then(response => {
                response.data._embedded.branch.forEach(data => {
                    this.branchOnlyList.push({
                      value: data.uuid,
                      text: data.name
                    })
                })
              })
            },
            getBranch (companyUuid = null) {
              this.isLoadingBranch = true
              if (companyUuid != null && this.tableFilter.company != null) {
                  this.doFilter()
                  this.tableFilter.branch_uuid = this.tableFilter.branch
                  this.tableFilter.branch = null
                  this.tableFilter.company_uuid = this.tableFilter.company
              } else {
                  this.doFilter()
                  this.tableFilter.branch = null
                  this.tableFilter.company = null
              }
              this.$http.get(window.AppConfig.apiUrl + 'branch?limit=100&company_uuid=' + companyUuid + '&is_active=1').then(response => {
                this.branchList = []
                this.isLoadingBranch = false
                response.data._embedded.branch.forEach(data => {
                    this.branchList.push({
                      value: data.uuid,
                      text: data.name
                    })
                })
              }).catch(error => {
                  window.consoleLog(error)
                  this.isLoadingBranch = false
              })
            },
        },
    }
</script>